import styled from 'styled-components'

export default styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  width: 570px;
  padding-top: 50px;
  box-sizing: border-box;
  
  @media (max-width: 570px) {
    width: 100%;
  }
`